import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-kids-ranking-classif',
  templateUrl: './kids-ranking-classif.component.html',
  styleUrls: ['./kids-ranking-classif.component.scss']
})

export class KidsRankingClassifComponent implements OnInit {
  /**
   * Definição para receber o identificador do ranking
   */
  rankingId: string;

  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
      this.rankingId = this.route.snapshot.paramMap.get('rankingId');
  }
}
